"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AncientShipyards = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const ResourceType_1 = require("../../ResourceType");
const StealResources_1 = require("../../deferredActions/StealResources");
const Resources_1 = require("../../Resources");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Units_1 = require("../../Units");
const MoonCard_1 = require("./MoonCard");
class AncientShipyards extends MoonCard_1.MoonCard {
    constructor() {
        super({
            name: CardName_1.CardName.ANCIENT_SHIPYARDS,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.SPACE],
            cost: 6,
            resourceType: ResourceType_1.ResourceType.RESOURCE_CUBE,
            reserveUnits: Units_1.Units.of({ titanium: 3 }),
            metadata: {
                description: 'Spend 3 titanium. -1 VP for every resource here.',
                cardNumber: 'M19',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Steal 8 M€ from any player and add a resource cube here.', (eb) => {
                        eb.empty().startAction.text('STEAL').nbsp().megacredits(8).any.nbsp().colon().nbsp().resourceCube(1);
                    }).br.br;
                    b.minus().titanium(3);
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.resourceCube(-1, 1),
            },
        });
        this.resourceCount = 0;
    }
    ;
    play(player) {
        super.play(player);
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const deferredAction = new StealResources_1.StealResources(player, Resources_1.Resources.MEGACREDITS, 8);
        deferredAction.stealComplete = () => {
            player.addResourceTo(this, 1);
        };
        player.game.defer(deferredAction);
        return undefined;
    }
    getVictoryPoints() {
        return -Math.floor(this.resourceCount);
    }
}
exports.AncientShipyards = AncientShipyards;
//# sourceMappingURL=AncientShipyards.js.map